import React, { useEffect, useState } from "react";
import useTableR from "../../useTableR";
import { Mensaje } from "../../mensajes2";
import axios from "axios";
import { Dimmer } from "../../spinner";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import moment from "moment";
import { formatMoneda } from "../../../util/varios";
const AnalisisModuloCaja = (props) => {
  const op = require("../../../modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const valorDolar = JSON.parse(localStorage.getItem("valorDolar"));
  const anioActual = new Date().getFullYear();
  const anios = Array.from(new Array(7), (val, index) => anioActual - index);
  const [tasa, setTasa] = useState(valorDolar);
  const [selectAnio, setSelectAnio] = useState(anioActual);
  const [loading, setLoading] = useState(false);
  const [loadingGrafic, setLoadingGrafic] = useState(false);
  const [dataTabla, setDataTabla] = useState([]);
  const [dataBarra, setDataBarra] = useState([]);
  const [propTabl, setPropTabl] = useState(false);
  const [fechas, setFechas] = useState({
    desde: new Date().toISOString().split("T")[0],
    hasta: new Date().toISOString().split("T")[0],
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const headCells = [
    {
      id: "1",
      label: "CUENTA INGRESO",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: ".875rem",
      color: "white",
    },

    {
      id: "2",
      label: "DESCRIPCION DE LA CUENTA",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: ".875rem",
      color: "white",
    },
    {
      id: "4",
      label: "Monto Recaudado Bs.",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: ".875rem",
      color: "white",
    },
    {
      id: "5",
      label: "Monto Recaudado $",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: ".875rem",
      color: "white",
    },
    {
      id: "6",
      label: "Acumulado Bs.",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: ".875rem",
      color: "white",
    },
    {
      id: "7",
      label: "Acumulado $",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: ".875rem",
      color: "white",
    },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableR(dataTabla, headCells, filterFn, true);
  const buscarRegistrosGrafica = async () => {
    try {
      setLoadingGrafic(true);
      const endpoint = `${op.conexion}/api/Caja_Ingreso/`;
      const response = await axios.get(
        endpoint,
        {
          params: {
            esPropio: propTabl,
            Tipo: 1,
            txtAnio: selectAnio,
          },
        },
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200 && response.data) {
        setDataBarra(response.data);
      } else {
        setDataBarra([]);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "Error al Buscar los Registros de las Graficas",
        icono: "error",
      });
    } finally {
      setLoadingGrafic(false);
    }
  };
  const buscarRegistros = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/Caja_Ingreso/`;
      const response = await axios.get(
        endpoint,
        {
          params: {
            txtFecInicio: moment.utc(fechas.desde).format("DD-MM-YYYY"),
            txtFechaFin: moment.utc(fechas.hasta).format("DD-MM-YYYY"),
            esPropio: propTabl,
            Tipo: 0,
          },
        },
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200 && response.data) {
        setDataTabla(response.data);
      } else {
        setDataTabla([]);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "Error al Buscar los Registros",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const imprimirGrafica = () => {
    try {
      window.open(
        `${op.reportes}/caja?reporte=GraficoIngresos&CONDICION=${propTabl}&ANIO=${selectAnio}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "Error al Generar el Reporte",
        icono: "error",
      });
    }
  };
  const imprimirTabla = () => {
    try {
      window.open(
        `${op.reportes}/caja?reporte=Tes_CajIngreso&CONDICION=true&INIFECHA='${moment.utc(fechas.desde).format("DD-MM-YYYY")}'&FINFECHA='${moment.utc(fechas.hasta).format("DD-MM-YYYY")}'&TIT_RGO1=DESDE EL ${moment.utc(fechas.desde).format("DD-MM-YYYY")} HASTA EL ${moment.utc(fechas.hasta).format("DD-MM-YYYY")}&isDolar=${true}&valorDolar=${parseFloat(tasa || 1).toFixed(2)}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "Error al Generar el Reporte",
        icono: "error",
      });
    }
  };
  useEffect(() => {
    buscarRegistros();
  }, [fechas, propTabl]);
  useEffect(() => {
    buscarRegistrosGrafica();
  }, [selectAnio, propTabl]);
  return (
    <div className="m-2" style={{ fontSize: "0.875rem" }}>
      <div className="card my-1 border-table">
        <div className="card-header bg-white border-0 pt-4 px-4">
          <div className="d-flex justify-content-between align-items-center gap-3">
            <h5 className="mb-0 fw-semibold text-uppercase">
              Resumen de Caja del Año {selectAnio}
            </h5>
            <div className="d-flex gap-2 align-items-center">
              <div
                className="input-group input-group-sm mb-0"
                style={{ width: "120px" }}
              >
                <span className="input-group-text text-uppercase">Año</span>
                <select
                  className="form-control text-uppercase"
                  value={selectAnio}
                  onChange={(e) => {
                    setSelectAnio(e.target.value);
                  }}
                >
                  {anios.map((e, index) => (
                    <option key={index} value={e}>
                      {e}
                    </option>
                  ))}
                </select>
              </div>

              <button
                onClick={() => imprimirGrafica()}
                className="btn btn-sm btn-info rounded-circle d-flex align-items-center justify-content-center"
                style={{ width: "31px", height: "31px", padding: 0 }}
              >
                <i className="fas fa-print"></i>
              </button>
            </div>
          </div>
        </div>
        <ResponsiveContainer width="100%" height="140">
          <BarChart responsive data={dataBarra}>
            <Tooltip
              formatter={(value) =>
                formatMoneda(value.toString().replace(".", ","), ",", ".", 2)
              }
            />
            <Bar
              dataKey="monto"
              fill="#3d8bfd"
              activeBar={{ fill: "#2563eb", stroke: "#2563eb" }}
              radius={[4, 4, 0, 0]}
            />

            <CartesianGrid stroke="#ccc" />
            <XAxis dataKey="mes" />
            <YAxis style={{ fontSize: "9px" }} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="card my-1 border-table">
        <div className="card-header bg-white border-0 pt-4 px-4">
          <div className="d-flex justify-content-between align-items-center gap-3">
            <h5 className="mb-0 fw-semibold text-uppercase">
              Resumen de Caja Desde el{" "}
              {moment(fechas.desde).format("DD/MM/YYYY")} hasta el{" "}
              {moment(fechas.hasta).format("DD/MM/YYYY")}
            </h5>
              {/* <div
              className="input-group input-group-sm  mb-0"
              style={{ width: "150px" }}
            >
              <span className="input-group-text text-uppercase">Tasa</span>
              <input
                type="text"
                className="form-control text-uppercase text-right"
                value={tasa}
                onChange={(e) => {
                  const valor = e.target.value.replace(".", ",");

                  // Si borra todo, guardamos un string vacío
                  if (valor === "") {
                    setTasa(1);
                    return;
                  }

                  // Si cumple con el formato de números y una coma, actualizamos el estado
                  if (/^[0-9]*,?[0-9]{0,2}$/.test(valor)) {
                    setTasa(valor);
                  } else {
                    setTasa(1);
                  }
                }}
              />
            </div> */}
            <div className="d-flex gap-2 align-items-center">
              <div
                className="text-uppercase mt-2 "
                style={{
                  width: "200px",
                  fontSize: "0.875rem",
                  fontWeight: "bold",
                }}
              >
                <label>
                  Ingresos Propios:{" "}
                  <input
                    type="checkbox"
                    name="myCheckbox"
                    onChange={(e) => setPropTabl(e.target.checked)}
                  />
                </label>
              </div>
              <div
                className="input-group input-group-sm  mb-0"
                style={{ width: "180px" }}
              >
                <span className="input-group-text text-uppercase">Desde</span>
                <input
                  type="date"
                  className="form-control text-uppercase text-right"
                  value={fechas.desde}
                  onChange={(e) => {
                    setFechas((prev) => ({
                      ...prev,
                      desde: e.target.value,
                    }));
                  }}
                />
              </div>
              <div
                className="input-group input-group-sm mb-0"
                style={{ width: "180px" }}
              >
                <span className="input-group-text text-uppercase">Hasta</span>
                <input
                  type="date"
                  className="form-control text-uppercase text-right"
                  value={fechas.hasta}
                  onChange={(e) => {
                    setFechas((prev) => ({
                      ...prev,
                      hasta: e.target.value,
                    }));
                  }}
                />
              </div>
              <button
                onClick={() => imprimirTabla()}
                className="btn btn-sm btn-info rounded-circle d-flex align-items-center justify-content-center"
                style={{ width: "31px", height: "31px", padding: 0 }}
              >
                <i className="fas fa-print"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />
            <tbody>
              {dataTabla &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                    }}
                  >
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: ".875rem",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.codigoingreso}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: ".875rem",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.descripcion}
                    </td>

                    <td
                      className="align-baseline"
                      style={{
                        fontSize: ".875rem",
                        textAlign: "right",
                        width: "auto",
                      }}
                    >
                      {formatMoneda(
                        parseFloat(item.monto).toString().replace(".", ","),
                        ",",
                        ".",
                        2,
                      )}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: ".875rem",
                        textAlign: "right",
                        width: "auto",
                      }}
                    >
                      {formatMoneda(
                        parseFloat(item.montoDolar)
                          .toString()
                          .replace(".", ","),
                        ",",
                        ".",
                        2,
                      )}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: ".875rem",
                        textAlign: "right",
                        width: "auto",
                      }}
                    >
                      {formatMoneda(
                        parseFloat(item.montoacumulado)
                          .toString()
                          .replace(".", ","),
                        ",",
                        ".",
                        2,
                      )}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: ".875rem",
                        textAlign: "right",
                        width: "auto",
                      }}
                    >
                      {formatMoneda(
                        parseFloat(item.montoAcumDolar)
                          .toString()
                          .replace(".", ","),
                        ",",
                        ".",
                        2,
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <div className="d-flex justify-content-end text-uppercase pt-2 text-end">
            <div
              style={{ width: "100%", maxWidth: "500px", fontSize: ".875rem" }}
            >
              <div className="row g-0 mb-1">
                <div className="col-8 fw-bold text-end pe-2">
                  Total Monto Recaudado Bs. :{" "}
                </div>
                <div className="col-4 text-end" style={{ fontSize: ".9rem" }}>
                  {formatMoneda(
                    (dataTabla?.[0]?.total || "0,00")
                      .toString()
                      .replace(".", ","),
                    ",",
                    ".",
                    2,
                  )}
                </div>
              </div>
              <div className="row g-0 mb-1">
                <div className="col-8 fw-bold text-end pe-2">
                  Total Monto Recaudado $:
                </div>
                <div className="col-4 text-end" style={{ fontSize: ".9rem" }}>
                  {formatMoneda(
                    parseFloat(dataTabla?.[0]?.montoTotalDolar)
                      .toString()
                      .replace(".", ","),
                    ",",
                    ".",
                    2,
                  )}
                </div>
              </div>
              <div className="row g-0 mb-1">
                <div className="col-8 fw-bold text-end pe-2">
                  Total Monto Acumulado Bs. :
                </div>
                <div className="col-4 text-end" style={{ fontSize: ".9rem" }}>
                  {formatMoneda(
                    (dataTabla?.[0]?.montoTotalAcum || 0)
                      .toString()
                      .replace(".", ","),
                    ",",
                    ".",
                    2,
                  )}
                </div>
              </div>
              <div className="row g-0 mb-1">
                <div className="col-8 fw-bold text-end pe-2">
                  Total Monto Acumulado $:
                </div>
                <div className="col-4 text-end" style={{ fontSize: ".9rem" }}>
                  {formatMoneda(
                    parseFloat(dataTabla?.[0]?.montoTotalAcumDolar)
                      .toString()
                      .replace(".", ","),
                    ",",
                    ".",
                    2,
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
          }}
        />
        <Dimmer active={loading || loadingGrafic} inverted />
      </div>
    </div>
  );
};

export default AnalisisModuloCaja;
